<template>
  <div class="changePwdBox">
    <!-- 更改成功弹框 -->
    <div v-if="changeYesFlag">
      <div class="mask"></div>
      <div class="new_pws">
        <div>
          <i class="el-icon-success"></i>
          <div>{{ success }}</div>
        </div>
        <div class="tips_info">{{ new_psd_time }}s 后自动跳转到个人中心</div>
      </div>
    </div>
    <!-- tabs切换 -->
    <div class="changeTabs">
      <div
        class="changeItem"
        @click="change(index)"
        :class="{ changeTabsActive: changeTabsActive == index }"
        v-for="(item, index) in tabsList"
        :key="index"
      >
        {{ item }}
        <div v-if="changeTabsActive == index" class="line"></div>
      </div>
    </div>
    <!-- 手机验证 -->
    <!-- <div v-if="changeTabsActive == 0" class="form_box">
      <div class="level level2">
        <div class="title"><span>*</span> 手机号：</div>
        <div>
          <input placeholder="请输入已绑定的手机号码" />
          <div class="tips">绑定后才能使用手机验证，<i>去绑定</i></div>

        </div>
      </div>
      <div class="level ">
        <div class="title"><span>*</span> 验证码：</div>
        <div class="yzm_box">
          <input placeholder="请输入手机验证码" />
          <button
            :class="{ yzm_btn_no: disabled2 }"
            :disabled="disabled2"
            class="yzm_btn"
            @click="getYzm"
          >
            {{ btnTitle }}
          </button>
        </div>
      </div>
      <div class="level">
        <div class="title"><span>*</span> 新密码：</div>
        <input placeholder="请输入6-20位新密码" />
      </div>
      <div class="level">
        <div class="title"><span>*</span> 确认密码：</div>
        <input placeholder="请再次输入密码" />
      </div>
      <div class="yesBtn">
        确认
      </div>
    </div>-->
    <!-- 密码验证 -->
    <div v-if="changeTabsActive == 1" class="form_box">
      <!-- 原密码 -->
      <div class="level">
        <div class="title">
          <span>*</span> 原密码：
        </div>
        <input placeholder="请输入原密码" v-model="oldPassword" />
      </div>
      <!-- 新密码 -->
      <div class="level">
        <div class="title">
          <span>*</span> 新密码：
        </div>
        <input placeholder="请输入6-12位新密码" v-model="newPassword" />
      </div>
      <!-- 确认密码： -->
      <div class="level">
        <div class="title">
          <span>*</span> 确认密码：
        </div>
        <input placeholder="请再次输入密码" v-model="aginPassword" />
      </div>
      <div @click="changeYes" class="yesBtn">确认</div>
    </div>
  </div>
</template>
<script>
import { updatepass } from "../../../assets/js/api.js";
import store  from 'store'
export default {
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      aginPassword: "",
      changeYesFlag: false,
      success: "更改成功",
      changeTabsActive: 1,
      // tabsList: ["手机验证", "密码验证"],
      tabsList: ["密码验证"],
      new_psd_time: "",
      btnTitle: "获取验证码",
      disabled2: false,
    };
  },
  methods: {
    change(i) {
      this.changeTabsActive = 1;
    }, // 获取验证码
    getYzm() {
      this.time = 60;
      this.timer = setInterval(() => {
        if (this.time == 0) {
          clearInterval(this.timer);
          this.btnTitle = "获取验证码";
          this.disabled2 = false;
        } else {
          this.btnTitle = this.time + "秒后重试";
          // this.btnTitle = "获取验证码" + "(" + this.time + ")";
          this.disabled2 = true;
          this.time--;
        }
      }, 1000);
    },
    // 更改成功
    changeYes() {
      if (!this.oldPassword) {
        this.$message.error("请输入原密码");
        return;
      }
      if (!this.newPassword) {
        this.$message.error("请输入新密码");
        return;
      }
      console.log(this.newPassword.length);
      if (this.newPassword.length < 6 || this.newPassword.length > 12) {
        this.$message.error("请输入6-12位新密码");
        return;
      }
      if (!this.aginPassword) {
        this.$message.error("请再次的输入密码");
        return;
      }
      if (this.aginPassword !== this.newPassword) {
        this.$message.error("两次密码不一致");
        return;
      }
      console.log(this.oldPassword, this.newPassword, this.aginPassword);
      updatepass(localStorage.getItem("info"), this.oldPassword, this.newPassword, this.aginPassword).then(
        (res) => {
            console.log("修改密码")
          console.log(res);
          if (res.code == 200) {
            this.changeYesFlag = true;
            this.success = "更改成功";
            this.new_psd_time = 3;
            this.timer2 = setInterval(() => {
              if (this.new_psd_time == 0) {
                clearInterval(this.timer2);
                this.$emit("getData", false);
              } else {
                this.new_psd_time--;
              }
            }, 1000);
          } else {
            console.log(res.msg)
            this.$message.error(res.msg);
          }
        }
      );
    },
  },
};
</script>
<style lang="less" scoped>
.changeTabsActive {
  color: #343434 !important;
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.6;
  z-index: 667;
}
.new_pws {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 770;
  width: 200px;
  height: 82px;
  background-color: #fff;
  border-radius: 10px;
  text-align: center;
  padding-top: 15px;
  box-sizing: border-box;
  > div:nth-child(1) {
    display: flex;
    align-items: center;
    justify-content: center;
    .el-icon-success {
      font-size: 28px;
      color: #4195f2;
      margin-right: 10px;
    }
    span {
      font-size: 14px;
      color: #000;
    }
  }

  > div:nth-child(2) {
    color: #4195f2;
    font-size: 12px;
    margin-top: 10px;
  }
}
.changePwdBox {
  margin-top: 40px;
  margin-left: 30px;
  .changeTabs {
    display: flex;
    .changeItem {
      font-size: 18px;
      color: #9a9a9a;
      margin-right: 30px;
      cursor: pointer;
      .line {
        width: 34px;
        height: 5px;
        background: #029aff;
        margin: 10px auto;
        border-radius: 5px;
      }
    }
  }
}
.form_box {
  margin-top: 20px;
  .level2 {
    margin-bottom: 15px !important;
  }
  .level {
    color: #343434;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    .tips {
      margin-top: 5px;
      font-size: 12px;
      color: #e62727;
      i {
        color: #029aff;
        cursor: pointer;
        font-style: normal;
      }
    }
    .title {
      width: 90px;
      text-align: right;
    }
    span {
      color: #e62727;
    }
    input {
      width: 340px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #cccccc;
      border-radius: 4px;
      padding-left: 20px;
      box-sizing: border-box;
    }
    .yzm_box {
      position: relative;
    }
    .yzm_btn {
      position: absolute;
      top: 50%;
      right: 15px;
      height: 90%;
      transform: translateY(-50%);
      color: #4296f2;
      font-size: 14px;
      border: none;
      background-color: #fff;
      cursor: pointer;
    }
  }
  .yesBtn {
    width: 144px;
    height: 40px;
    background: #029aff;
    border-radius: 4px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    margin-left: 190px;
    cursor: pointer;
  }
}
</style>
